import React from 'react';
import { Stack, Typography, Paper, Avatar, Container, Grid } from '@mui/material';

export const About = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Stack spacing={4}>
        <Stack spacing={1} sx={{ textAlign: 'center' }}>
          <Typography variant="h3" component="h1" sx={{ fontWeight: 700 }}>
            About Gobotic
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Building the future of autonomous systems and artificial intelligence.
          </Typography>
        </Stack>

        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, md: 4 },
            borderRadius: 3,
            border: '1px solid rgba(255,255,255,0.08)',
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 3,
            alignItems: { xs: 'center', sm: 'flex-start' },
          }}
        >
          <Avatar
            sx={{
              width: { xs: 80, sm: 100 },
              height: { xs: 80, sm: 100 },
              bgcolor: 'primary.main',
              fontSize: { xs: '2rem', sm: '2.5rem' },
              fontWeight: 700,
            }}
          >
            KL
          </Avatar>
          <Stack spacing={1}>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              Karl Lilje
            </Typography>
            <Typography variant="body2" sx={{ color: 'primary.main', fontWeight: 500 }}>
              Founder and Owner
            </Typography>
          </Stack>
        </Paper>

        <Stack spacing={3}>
          <Typography variant="body1" sx={{ lineHeight: 1.8, color: 'text.secondary' }}>
            GOBOTIC is a technology suite specializing in the development and deployment of advanced robotics and AI solutions. The mission is to revolutionize industries by integrating cutting-edge technology to enhance efficiency, safety, and user experience.
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.8, color: 'text.secondary' }}>
            The GOBOS Robot Operating System powers service delivery robots designed for various applications, including last-mile delivery, security patrols, and customer service. These robots are equipped with advanced navigation systems, sensors, and AI capabilities to operate autonomously in diverse environments.
          </Typography>
        </Stack>

        <Grid container spacing={3} sx={{ mt: 2 }}>
          {[
            { title: 'Robotics', desc: 'Autonomous service and delivery robots for real-world environments.' },
            { title: 'AI Solutions', desc: 'Face recognition, vector databases, and intelligent decision-making.' },
            { title: 'GOBOS', desc: 'A dedicated Robot Operating System built for reliability and scale.' },
          ].map((item, index) => (
            <Grid item xs={12} sm={4} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  borderRadius: 3,
                  border: '1px solid rgba(255,255,255,0.08)',
                  height: '100%',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    borderColor: 'primary.main',
                  },
                }}
              >
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
                  {item.title}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.6 }}>
                  {item.desc}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Container>
  );
};
